import _ from 'lodash';
import React, { useState } from 'react';
import config from 'client/shared/config';
import { inject } from 'mobx-react';

import {
	CardNumberElement,
	CardCvcElement,
	CardExpiryElement,
	useStripe,
	useElements
} from '@stripe/react-stripe-js';

import {
	FieldFactory
} from 'client/shared/components';

const CARD_ELEMENT_OPTIONS = {
	iconStyle: 'solid',
	style: {
		base: {
			'color': '#fff',
			'fontFamily': "'NTR', sans-serif",
			'fontSize': '1.2rem',
			'borderBottom': '1px solid #fff'
		},
		invalid: {
			iconColor: '#eb1c26',
			color: '#eb1c26',
		}
	}
};

const Field = (props) => (
	<FieldFactory
		{ ...props }
		noFieldClass
	/>
);

const CheckOutFormSubmitButton = ({ submit }) => (
	<div className="row" style={{'justifyContent': 'center'}}>
		<button
			className="button neo subscribeModal expanded margin-top-0 margin-bottom-0"
			onClick={ submit }
			style={{width: '8vw'}}
		>
			Save
		</button>
	</div>
);

const CheckOutFormCancelButton = ({ cancel }) => (
	<div className="row" style={{'justifyContent': 'center'}}>
		<button
			className="button neo subscribeModal expanded margin-top-0 margin-bottom-0"
			onClick={ cancel }
			style={{width: '8vw'}}
		>
			Cancel
		</button>
	</div>
);

const CheckoutFormCardSelect = ({activeCard, setEditing, showButtons }) => {
	const commonStyles = {color: 'white', textDecoration: 'underline'}
	let {card} = activeCard;
	if(_.isEmpty(card)) {
		return (
			<div>
				<div className="section-title" style={{ color: 'white', fontSize: '1.2em' }}>Active Payment Method</div>
				<div className="row grid-x align-justify margin-bottom-1" style={{ alignItems: 'center' }}>
					<div className="cell-4">
						No payment information found.
					</div>
					<div className="cell-4">
						<button
							className="button neo"
							style={{ visibility: showButtons ? 'visible' : 'hidden' }}
							onClick={() => { setEditing(true)}}
							data-ta="add-payment-method-button"
						>
							Add a Card
						</button>
					</div>
				</div>
			</div>
		)
	}

	return (
		<div style={{ marginTop: '13vh'}}>
			<div className="section-title" style={{ color: 'white', fontSize: '1.2em' }}>Active Payment Method</div>
			<div className="row grid-x align-justify" style={{ alignItems: 'center' }}>
				<div className="cell-12">
					{card.brand} Ending in {card.last4} | Expiration: {card.exp_month}/{card.exp_year}
				</div>
			</div>

			{
				showButtons && <div className="row grid-x">
					<div className="cell-6">
						<a style={{ ...commonStyles, width: '5vw', marginRight: '2vw' }} onClick={() => { setEditing(true)}}>Edit</a>
					</div>
				</div>
			}
		</div>
	);
};

const injectWithStores = inject('userStore', 'apiStore', 'formStore');

export default injectWithStores(
	({ userStore, apiStore, formStore, handleCloseModal, notify, errorToast, activeCard}) => {

		const [ editing, setEditing, ] = useState(false);
		const [ adding, setAdding, ] = useState(false);
		const stripe = useStripe();
		const elements = useElements();
		const member = userStore.getLoggedInUser();

		return (
			<div className="checkout margin-horizontal-1 margin-bottom-1">
				<CheckoutFormCardSelect 
					data-ta="checkout-form-card-select"
					activeCard={activeCard} 
					showButtons={ !editing }	
					setEditing={setEditing}
				/>
				

				{/*TODO: Find way to speed up async rendering time or hide/delay 'editing' stage */}
				<div className="grid-x align-center margin-top-1">
					{ editing &&
						<div className="grid-x align-middle">

							{/*Card Num*/}
							<div className="grid-x margin-bottom-2 cell small-12">
								<div className="cell small-5 margin-right-1 underlined-field">
									<Field
										fieldKey="user.cardName"
										formStore={ formStore }
										item={ member }
										placeholder="Name on Card"
									/>
								</div>
								<div className="cell small-5 margin-right-1">
									<label className="card-elem-label">
										Card Number
										<div className="underlined-field" data-ta="card-number-element">
											<CardNumberElement
												id="subscribeCardNumber"
												options={ CARD_ELEMENT_OPTIONS }
											></CardNumberElement>
										</div>
									</label>
								</div>
							</div>

							{/*Card Expiry and CVC*/}
							<div className="grid-x margin-bottom-2 cell small-12">
								<div className="cell small-5 margin-right-1">
									<label className="card-elem-label">
										Expiration Date
										<div className="underlined-field" data-ta="card-expiration-date-element">
											<CardExpiryElement
												id="subscribeCardExpirationDate"
												options={ CARD_ELEMENT_OPTIONS }
											></CardExpiryElement>
										</div>
									</label>
								</div>
								<div className="cell small-5 margin-right-1">
									<label className="card-elem-label">
										CVC
										<div className="underlined-field" data-ta="card-cvc-element"	>
											<CardCvcElement
												id="subscribeCardCVC"
												options={ CARD_ELEMENT_OPTIONS }
											></CardCvcElement>
										</div>
									</label>
								</div>
							</div>

							{/*Card Expiry and CVC*/}
							<div className="grid-x cell small-12">
								<div className="cell small-5 margin-bottom-2 underlined-field">
									<Field
										fieldKey="user.postalCode"
										formStore={ formStore }
										item={ member }
										placeholder="#####"
									/>
								</div>
							</div>

							<CheckOutFormSubmitButton
								submit={async () => {
									const card = elements.getElement(CardNumberElement);
									const { paymentMethod, error: pmError } = await stripe.createPaymentMethod({
										type: 'card',
										card,
										billing_details: {
											name: member.cardName,
											address: {
												postal_code: member.postalCode
											}
										}
									});

									if (pmError || _.isEmpty(paymentMethod)) {
										errorToast();
										return;
									}

									try {
										const route = config.getRoute('attachPaymentMethod', paymentMethod.id);
										await apiStore.save({
											route,
											payload: {
												memberID: member.id
											}
										});
										setEditing(false);
										handleCloseModal();
										notify();
									} catch (err) {
										console.error('[card-form] attach payment method', err);
										errorToast();
									}
								}}
							/>
							{/* <CheckOutFormCancelButton
								cancel={() => setAdding(false)}
							/> */}
						</div>
					}
				</div>
			</div>
		);
	}
);
